import { render, staticRenderFns } from "./CardBig.vue?vue&type=template&id=1a45cb64&"
import script from "./CardBig.vue?vue&type=script&lang=js&"
export * from "./CardBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports